var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { NotFoundError } from '@lucidlink/sdk/fetcher';
import { assertCanHandle } from '@lucidlink/tscore';
import { useAuthProvider, useLucidSdk } from '#context';
import { OrganizationInvitationsKeyFactory } from '../../query-key-factories';
import { useCurrentMemberByWorkspaceId } from './useCurrentMemberByWorkspaceId';
export const useGetOrganizationInvitation = (workspaceId) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const { query: { data }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const query = useQuery({
        queryKey: OrganizationInvitationsKeyFactory.byWorkspace(workspaceId),
        queryFn: async () => {
            try {
                return await lucidSdk
                    .workspaceClient(workspaceId)
                    .invitationManagement()
                    .getOrganizationInvitation();
            }
            catch (e) {
                assertCanHandle(e, (e) => e instanceof NotFoundError);
                return null;
            }
        },
        enabled: Boolean(workspaceId &&
            data?.privileges?.membersOrgInvite &&
            currentUser?.emailVerified),
        networkMode: 'always',
        retry: false,
        refetchOnWindowFocus: false,
    });
    return { query };
};
_react_refresh_temp_1(useGetOrganizationInvitation, "BqtYlYFpCya613Jh04c4V4flQrM=", false, () => [useLucidSdk, useAuthProvider, useCurrentMemberByWorkspaceId, useQuery]);
